/** Shared copy for catalog branch on Heritage vendor catalog sync. */

export const HERITAGE_REFRESH_STOCK_BRANCH_VENDOR_HELP =
  "Download Purchase History loads what your company has actually ordered from Heritage in the last 12 months — the list worth linking to your items. Those orders may span branches, so they are not tagged with one. The full branch catalog is still available under ▾; it covers everything Heritage stocks there, including product lines you do not sell, and it is what tags items with a branch for sending purchase orders. The Link screen searches the local cache. Stock is checked live when you send a purchase order.";

export const HERITAGE_REFRESH_STOCK_BRANCH_SEND_MISSING =
  "No catalog branch is stored for these items yet. In Vendors, open Edit Vendor for this Heritage vendor, select your ordering branch, and run Download Branch Items.";

export const HERITAGE_SEND_CATALOG_BRANCH_HINT =
  "Branch comes from the Heritage catalog (heritage_product_list_items) — set when you download the branch catalog in Edit Vendor. Send uses that branch; it is not chosen here.";

export function heritageSendBranchSourceHint(
  branchSource: "catalog" | "vendor" | "company_default"
): string {
  if (branchSource === "catalog") {
    return "Default branch from catalog items tagged with a branch during branch catalog download.";
  }
  if (branchSource === "vendor") {
    return "Default branch from this vendor's Heritage settings. Run Download Branch Items in Edit Vendor to load the branch catalog.";
  }
  return "Company default branch. Run Download Branch Items in Edit Vendor to load the branch catalog.";
}
